import { ProtectedRoute } from "@app/protected-route";
import { ResultPage } from "@pages/result-page/result-page";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParamsApplication {
	tab?: "ocr" | "scoring";
}

export const Route = createFileRoute("/_layout/applications/$applicationId")({
	component: RouteComponent,
	validateSearch: (search: SearchParamsApplication) => {
		return {
			tab: search.tab || "ocr",
		};
	},
});

function RouteComponent() {
	return (
		<ProtectedRoute
			requiredPermissions={[
				"see_all_logs",
				"create_and_score_application",
				"read_results",
			]}
		>
			<ResultPage />
		</ProtectedRoute>
	);
}
